var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 208.31 168.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00a298;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m168.59,19.87l9.26-9.26c40.63,40.63,40.63,106.74,0,147.37l-9.26-9.26c35.52-35.52,35.52-93.33,0-128.85Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m30.47,10.61l9.26,9.26c-35.52,35.52-35.52,93.33,0,128.85l-9.26,9.26C-10.16,117.34-10.16,51.23,30.47,10.61Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m83.61,2.58c21.83-5.49,44.49-2.14,63.8,9.41,19.31,11.55,32.97,29.94,38.46,51.76l-10.27,2.58c-4.8-19.08-16.74-35.16-33.63-45.26-16.89-10.1-36.7-13.03-55.78-8.23l-2.58-10.27h0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m22.44,104.83l10.27-2.58c4.8,19.08,16.74,35.16,33.63,45.26,16.88,10.11,36.7,13.03,55.78,8.23l2.58,10.27c-21.83,5.49-44.49,2.14-63.8-9.41s-32.97-29.94-38.46-51.77h0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m55.78,35.85c7.1-7.1,15.75-12.58,25.5-16.05,17.22-6.11,35.8-5.15,52.3,2.71l-3.69,7.76c-14.42-6.87-30.67-7.71-45.73-2.37-15.06,5.34-27.14,16.23-34.01,30.66l-7.76-3.69c3.41-7.17,7.94-13.57,13.4-19.02Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m78.43,138.3c14.42,6.87,30.67,7.71,45.73,2.37,15.06-5.34,27.14-16.23,34.01-30.66l7.76,3.69c-7.86,16.5-21.68,28.95-38.9,35.06-17.22,6.11-35.8,5.15-52.3-2.71l3.69-7.76h0Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m104.44,28.64c30.69.16,55.53,25.26,55.37,55.94l-7-.04c.14-26.84-21.58-48.78-48.42-48.91l.04-7h0Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m48.5,84.01l7,.04c-.07,13,4.93,25.24,14.08,34.48,9.14,9.24,21.34,14.36,34.34,14.43l-.04,7c-14.87-.07-28.81-5.94-39.27-16.51-10.46-10.57-16.18-24.57-16.1-39.43h0Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m139.83,67.93l5.13-2.36c5,10.9,5.46,23.1,1.29,34.33-4.17,11.24-12.46,20.19-23.36,25.19l-2.36-5.13c9.52-4.37,16.79-12.2,20.43-22.02,3.64-9.83,3.24-20.49-1.12-30.02h0Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m72.38,52.55c3.72-3.72,8.12-6.8,13.05-9.06l2.36,5.13c-9.52,4.37-16.79,12.2-20.43,22.02s-3.24,20.49,1.12,30.02l-5.13,2.36c-5-10.9-5.45-23.09-1.29-34.34,2.28-6.16,5.81-11.62,10.31-16.13Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.65651851b9027bab4118e4499ccf3cec.svg";
export { ForwardRef as ReactComponent };